import { companyAvatar } from 'Services/avatarGenerator'

/**
 * @param {ApiCategoryDirectoryCompany} company
 * @returns {CategoryDirectoryCompany}
 */
export const parseCategoryBox = (company) => {
  return {
    id: company.id,
    name: company.name,
    servicesDescription: company.servicesDescription,
    logo: company.logo,
    city: company.city,
    uf: company.uf,
    category: company.category,
    serviceType: company.serviceType,
    totalEvaluation: company.totalEvaluation,
    rating: company.rating ? parseFloat(company.rating) : null,
    slug: company.slug,
    isChecked: company.isChecked,
    isFavorite: false,
    is360Partner: company.is360Partner,
    participationIndex: company.participationIndex

  }
}

/**
 * @param {ApiCategoryDirectoryCompany} company
 * @returns {CategoryDirectoryCompany}
 */
export const parseFavoriteCategoryBox = (company) => {
  let favoriteCompany = parseCategoryBox(company)
  favoriteCompany.isFavorite = true

  return favoriteCompany
}

/**
 * @param {ApiServiceType} service
 */
export const parseDirectoryService = (service) => ({
  id: service.id,
  name: service.name,
  slug: service.slug,
})

/**
 * @param {ApiCategoryDirectoryCompany[]} favoriteList
 * @returns (company => CategoryDirectoryCompany)
 */
export const favoriteCompanyMapper = favoriteList => company => {
  const isFavorite = favoriteList.some(f => f.id === company.id)

  return { ...company, isFavorite }
}

export default {
  parseCategoryBox,
  parseFavoriteCategoryBox,
  parseDirectoryService,
  favoriteCompanyMapper,
}